<template>
  <slot></slot>
  <modal :id="modalId" :title="modalTitle">
    <form :id="formId" :action="action" method="POST" role="form">

      <div v-if="!isOther" class="form-group row">
        <label for="keywords" class="col-sm-2 col-form-label">Keywords:</label>
        <div class="col-sm-10 pt-2">
          <div class="keyword-labels">
            <span v-for="keyword in keywordList" class="badge badge-secondary mr-1">
              {{ keyword }} <i class="fa fa-times" v-if="keywordList.length > 1" @click="removeKeyword(keyword)"></i>
            </span>
          </div>

          <div class="input-group mt-2">
            <input type="text" class="form-control" v-model="newKeyword" @keydown.enter.prevent="addKeyword()" placeholder="Type in a new keyword and press Enter to add">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" type="button" @click="addKeyword()" :disabled="!newKeyword"><i class="fa fa-plus-circle"></i></button>
            </div>
          </div>

          <input type="hidden" name="keywords" id="keywords" :value="keywords" />
        </div>
      </div>

      <div class="form-group row">
        <label for="response_id" class="col-sm-2 col-form-label">Default Response:</label>
        <div class="col-sm-10">
          <select class="form-control" name="response_id" id="response_id">
            <option v-for="(response, id) in responses" :value="id" :selected="parseInt(id) === parseInt(responseId)">
              {{ response }}
            </option>
          </select>
        </div>
      </div>

      <div v-if="isDeployment" class="form-group row">
        <label for="status" class="col-sm-2 col-form-label">Status Update:</label>
        <div class="col-sm-10">
          <select class="form-control" name="status">
            <option v-for="(statusTitle, statusName) in allStatuses" :value="statusName" :selected="status === statusName">
              {{ statusTitle }}
            </option>
          </select>
        </div>
      </div>

      <input type="hidden" name="_method" :value="method">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
      <button type="submit" class="btn btn-primary" :form="formId"><i class="fa fa-fw fa-save"></i> Save changes</button>
    </template>
  </modal>
</template>

<script>
import HasModal from "../../mixins/HasModal";

export default {
  mixins: [HasModal],

  props: {
    // Custom id for modal component.
    modalId: {
      type: String,
      default: 'reply-options-modal'
    },
    // List of all existing adjuster statuses.
    statuses: {
      type: Object,
      default: () => {return {};}
    },
    id: {
      type: Number,
      default: 0
    },
    action: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    initialKeywords: {
      type: String,
      default: ''
    },
    isOther: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ''
    },
    isDeployment: {
      type: Boolean,
      default: false
    },
    responseId: {
      type: Number,
      default: 0
    },
    responses: {
      type: Object,
      default: () => {return {};}
    }
  },

  data() {
    return {
      newKeyword: '',
      keywords: this.initialKeywords,
    }
  },

  computed: {
    formId() {
      return this.modalId + '-form';
    },
    modalTitle() {
      return 'Edit "' + this.title + '" reply option';
    },
    method() {
      return "PATCH";
    },
    isExisting() {
      return this.id > 0;
    },
    keywordList() {
      return !this.keywords ? [] : this.keywords.split('|');
    },
    allStatuses() {
      let allStatuses = this.statuses;
      allStatuses[''] = "[Don't update status]";
      return allStatuses;
    },
  },
  methods: {
    addKeyword() {
      if (this.newKeyword) {
        if (this.newKeyword.includes('|')) return;

        let list = this.keywordList;
        if (list.indexOf(this.newKeyword) === -1) {
          list.push(this.newKeyword);
          this.keywords = list.join('|');
        }
        this.newKeyword = '';
      }
    },
    removeKeyword(keyword) {
      this.keywords = this.keywordList.filter(item => item !== keyword).join('|');
    },
  }
}

</script>

<style scoped>
.fa-times {
  cursor: pointer;
}
</style>
